import type { ReactNode } from 'react';

type AccentColor = 'violet' | 'teal' | 'green' | 'amber';

export function KpiCard({
  label,
  value,
  delta,
  deltaDirection,
  color,
  icon,
}: {
  label: string;
  value: string;
  delta?: string;
  deltaDirection?: 'up' | 'down';
  color: AccentColor;
  icon: ReactNode;
}) {
  return (
    <div className="kpi">
      <div className="kpi-top">
        <span className="kpi-label">{label}</span>
        <div className={`kpi-icon ${color}`}>{icon}</div>
      </div>
      <div className="kpi-value">{value}</div>
      {delta && (
        <span className={`kpi-delta ${deltaDirection ?? 'up'}`}>{delta}</span>
      )}
    </div>
  );
}
